'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.toggle = exports.saveData = undefined;

var _reduxActions = require('redux-actions');

var _traverse = require('traverse');

var _traverse2 = _interopRequireDefault(_traverse);

var _actionTypes = require('../action-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saveData = exports.saveData = (0, _reduxActions.createAction)(_actionTypes.CMS_COMPONENT_SUB_MENU_DROPDOWN_SAVE_DATA, function (tree, categoryId, id) {
	var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	var data = {
		current: undefined,
		parent: undefined,
		children: []
	};

	(0, _traverse2.default)(tree).forEach(function (x) {
		if (x && x.categoryId === categoryId) {
			data.current = x;
			data.parent = this.parent.parent.node;

			if (x.children.length === 0 && opts.siblingFallback) {
				data.children = this.parent.node;
			}

			if (x.children.length !== 0) {
				data.children = x.children;
			}

			this.stop();
		}
	});

	return {
		data: data,
		id: id
	};
});

var toggle = exports.toggle = (0, _reduxActions.createAction)(_actionTypes.CMS_COMPONENT_SUB_MENU_DROPDOWN_TOGGLE, function (id, forceClose) {
	return { id: id, forceClose: forceClose };
});